<ng-container *ngIf="ctx" [ngSwitch]="mainService.getShopPortalLayoutKind()">
    <app-promotions-overview-boxed-layout-component *ngSwitchDefault [ctx]="ctx"></app-promotions-overview-boxed-layout-component>
    <app-promotions-overview-scroll-layout-component *ngSwitchCase="1" [ctx]="ctx"></app-promotions-overview-scroll-layout-component>
</ng-container>
  